import { invoiceActionStatus } from "@/lib/utils";
import { setGls, setInvoiceDueDate, setVendors } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useGetVendorsGlSpend } from "@/services";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useOperational = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const currentFinanceYear = useSelector(
    (state: RootState) => state.currentData.currentFinanceYear
  );

  const { data: vendorGlData, isLoading: isVendorGlDataLoading } =
    useGetVendorsGlSpend({
      communityId: communityDetail?.communityId,
      year: currentFinanceYear,
      queryParams: {
        enabled: !!(communityDetail?.communityId && currentFinanceYear),
      },
    });

  const onTopVendorsClick = () => {
    navigate(`${routes.invoice}/${invoiceActionStatus.posted}`);
    dispatch(setInvoiceDueDate(null));
    dispatch(
      setVendors(vendorGlData?.data?.topVendors?.map((data: any) => data?.name))
    );
  };

  const onTopGlClick = () => {
    navigate(`${routes.payment}/${routes.reports}`);
    dispatch(setGls(vendorGlData?.data?.topGls?.map((data: any) => data?.id)));
  };

  return {
    vendorGlData,
    isVendorGlDataLoading,
    onTopVendorsClick,
    onTopGlClick,
  };
};

export default useOperational;
